import { 
    Coffee, 
    Dumbbell, 
    Car, 
    Utensils, 
    Map, 
    Bed, 
    Wine, 
    ShoppingBag,
    Shirt
  } from 'lucide-react';
  
  interface CategoryIconProps {
    category: string;
    className?: string;
  }
  
  export function CategoryIcon({ category, className = "" }: CategoryIconProps) {
    // Map category names to appropriate icons
    switch (category.toLowerCase()) {
      case 'food & drinks':
        return <Coffee className={className} />;
      case 'wellness':
        return <Dumbbell className={className} />;
      case 'transportation':
        return <Car className={className} />;
      case 'room services':
        return <Bed className={className} />;
      case 'activities':
        return <Map className={className} />;
      case 'dining':
        return <Utensils className={className} />;
      case 'shopping':
        return <ShoppingBag className={className} />;
      case 'laundry':
        return <Shirt className={className} />;
      case 'wine & spirits':
        return <Wine className={className} />;
      default:
        // Default icon for unknown categories
        return <ShoppingBag className={className} />;
    }
  }